module.exports = __webpack_public_path__ + "img/download-1.7d79fe77.svg";